import McMessageList from './McMessageList';

export default McMessageList;
